// Imports
import { Fragment, ReactNode, useEffect, useState } from "react";
import { angularEvents } from "../../bridge/angularEvents";
import { Formik, Field, FieldArray, Form, ErrorMessage, FormikProps, FormikConfig } from "formik";
import { reactEvents } from "../../bridge/reactEvents";
import AssortmentPlanningProductDetailTable from '../components/assortmentPlanningProductDetailTable';
import AssortmentPlanningProductTable, { ApiProduct, Period, Product } from '../components/assortmentPlanningProductTable';
import CreateProduct from '../components/createProduct';
import CreatePreOrder from '../components/createPreOrder';

// Exports
export function AssortmentPlanning(props: AnimationPlaybackEvent) {
	const [collection, setCollection] = useState(20281);
	const [brand, setBrand] = useState('');
	const [option1, setOption1] = useState('');
	const [error, setError]  = useState('');
	const [products, setProducts] = useState<Array<Product>>([]);
	const [rawProducts, setRawProducts] = useState<Array<ApiProduct>>([]);
	const [currentProduct, setCurrentProduct] = useState<Product>();
	const [currentRawProduct, setCurrentRawProduct] = useState<ApiProduct>();
	const [currentCell, setCurrentCell] = useState('');
	const [currentPeriod, setCurrentPeriod] = useState(-1);
	const [invalidProducts, setInvalidProducts] = useState(1);

	const HandleCollectionChange = (event: any) => {
		setCollection(event.target.value);
	  }
	
	  const onCurrentProductChange = (newCurrentProduct: any) => {
		setCurrentProduct(newCurrentProduct);
	
		var rawProduct = rawProducts.find(o => o.productNumber === newCurrentProduct.productNumber);
		setCurrentRawProduct(rawProduct);
	  }
	
	  const onCurrentCellChanged = (newCell: any) => {
		setCurrentCell(newCell);
		setCurrentPeriod(newCell);
	  }
	
	  const onCreatedPreOrder = (newCell: any) => {
		setInvalidProducts(invalidProducts + 1);
	  }
	
	  const getPeriodQuantity = (periods: Array<Period>, index: number): number | string => {
		if (periods === null)
			return '';
	
		var period = periods.find(o => o.period === index);
		if (period == null) {
			return '';
		}
	
		return period.plannedQuantity > 0 ? period.plannedQuantity : '';
	}

	const fetchProducts = async () => {
		try {
		  const response = await fetch('https://dev-rms2.cleverapps.se/api/assortmentplanning/products?collection=' + collection, {
			method: 'GET',
			headers: {
			  "X-Cleverapps-Tenant": "int2",
			  "Authorization": "dc273ac289084f5eacd83dad63fab1e8",
			  "Content-Type": "application/json"
			}
		  });
		  if (!response.ok) {
			throw new Error('Network response was not ok with collection ' + JSON.stringify(collection));
		  }
		  let responseData = await response.json();
	
		  setRawProducts(responseData.products);
	
		  // map the response to the local product structure
		  let mappedProducts: Product[] = responseData.products.map((product: any) => {
			return { 
			  collection: product.collection,
			  supplier: product.supplier,
			  productNumber: product.productNumber,
			  option1: product.option1,
			  brand: product.brand,
			  category: product.category,
			  onHand: product.onHand,
			  onOrder: product.onOrder,
			  totalPlannedQuantity: product.totalPlannedQuantity,
			  period1: getPeriodQuantity(product.periods, 1),
			  period2: getPeriodQuantity(product.periods, 2),
			  period3: getPeriodQuantity(product.periods, 3),
			  period4: getPeriodQuantity(product.periods, 4),
			  period5: getPeriodQuantity(product.periods, 5),
			  period6: getPeriodQuantity(product.periods, 6)
			 }
		  });
		  setProducts(mappedProducts);
	
		  //setError(JSON.stringify(mappedProducts));
		} catch (err: any) {
		  setError(err.message);
		  setProducts([]);
		}
	  }

	useEffect(() => {
		fetchProducts();
	  }, [collection, invalidProducts]);

    // Render this if we have all the information we need to present the UI
    return (
		<div className="App">
		<p>Collection: {collection}</p>
		<p>Error: {error}</p>
		<input type={'text'} value={collection} onChange={HandleCollectionChange}/>
		<AssortmentPlanningProductTable products={products} onCurrentProductChanged={onCurrentProductChange} onCurrentCellChanged={onCurrentCellChanged} />
		<AssortmentPlanningProductDetailTable orders={currentRawProduct?.periods.find(o => o.period === currentPeriod)?.plannedOrders} onCurrentProductChanged={onCurrentProductChange} onCurrentCellChanged={onCurrentCellChanged} />
		<CreateProduct collection={collection} />
		<CreatePreOrder collection={collection} period={currentPeriod} currentProduct={currentProduct} onCreatedPreOrder={onCreatedPreOrder} />
		<p>{currentProduct?.brand}, {currentProduct?.productNumber}, {currentProduct?.collection}, Cell: {currentCell}</p>
		<p>Raw product: {JSON.stringify(currentRawProduct)}</p>
	  </div>
    );
}


// Classes
export class ArticleColours {
    ArticleId: number = 0;
    ArticleColours: ArticleColour[] = [];
    UniqueColourNames: string[] = [];
}
class ArticleColour {
    ArticleVariantId: number = 0;
    ColourName: string = "";
}

export type PlannedOrder = {
    orderId: string
    quantity: number
    lineItems: Array<PlannedOrderLineItem>
}

export type PlannedOrderLineItem = {
    locationNumber: number
    quantity: number
    option2: string 
}

const defaultData: Product[] = [
    {
        productNumber: '123457890',
        brand: 'Adidas',
        category: 'HerrByxa',
        supplier: 'A.Supplier',
        totalPlannedQuantity: 50,
        collection: 20241,
        onHand: 200,
        onOrder: 150,
        option1: 'Red',
        period1: 150,
        period2: 150,
        period3: 150,
        period4: 150,
        period5: 150,
        period6: 150
    }
]